import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core';
import useStyles from './styles';

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
      cursor: 'pointer',
    },
  },
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
  root: {
    border: 'none',
    '&:first-child': {
      borderTopLeftRadius: '5px',
      borderBottomLeftRadius: '5px',
    },
    '&:last-child': {
      borderTopRightRadius: '5px',
      borderBottomRightRadius: '5px',
    },
  },
  head: {
    color: theme.palette.text.title,
  },
}))(TableCell);

function PostsTable({ data, head, lastPostRef, loading, onRowClick = () => {}, rows }) {
  const classes = useStyles();

  return (
    <TableContainer component={Box}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {head.map(col =>
              <StyledTableCell key={col.id}>
                <Typography className={classes.titles}>{col.label}</Typography>
              </StyledTableCell>
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((post, postIndex) => {
            const row = rows.map((r, index) => {
              const d = post[r.accessor];

              return (
                <StyledTableCell key={post.id + '/' + index} style={{ minWidth: r.width ?? '', width: r.width ?? '' }}>
                  {!r.Cell ? <Typography variant='body2'>{d}</Typography> : r.Cell(d)}
                </StyledTableCell>
              )
            });

            if (data.length === postIndex + 1) return (
              <StyledTableRow key={`row-${postIndex}`} ref={lastPostRef} onClick={() => onRowClick(post)}>
                {row.map(r => r)}
              </StyledTableRow>
            )

            return (
              <StyledTableRow key={`row-${postIndex}`} onClick={() => onRowClick(post)}>
                {row.map(r => r)}
              </StyledTableRow>
            )
          })}

          {loading &&
            <TableRow>
              <StyledTableCell className={classes.rowCell} colSpan={head.length}>
                <CircularProgress size={50} />
              </StyledTableCell>
            </TableRow>
          }

          {data.length === 0 && !loading &&
            <StyledTableRow>
              <StyledTableCell className={classes.rowCell} colSpan={head.length}>
                <Typography>Aucun post n'a été créé pour le moment</Typography>
              </StyledTableCell>
            </StyledTableRow>
          }
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default PostsTable;
